import { gsap } from 'gsap';
import gsapCore from 'gsap/gsap-core';
import Scrolltrigger from 'gsap/ScrollTrigger';
gsap.registerPlugin(Scrolltrigger);
gsap.config({ nullTargetWarn: false, });

gsap.fromTo(".elem0", { opacity: 0 }, { opacity: 1, duration: 1 });
gsap.fromTo(".elem1", { opacity: 0 }, { opacity: 1, duration: 1, delay: 1 });
gsap.fromTo(".elem2", { opacity: 0 }, { opacity: 1, duration: 1, delay: 2 });
gsap.fromTo(".elem3", { opacity: 0 }, { opacity: 1, duration: 1, delay: 3 });
gsap.fromTo(".elem4", { opacity: 0 }, { opacity: 1, duration: 1, delay: 4 });
